import {
  startStream,
  stopStream,
  finishStream,
  isCurrentStream,
} from "@/utils/streamControllers";
import {
  streamList,
  StreamError,
  isRetryable,
  RETRY_LIMIT,
  retryDelay,
} from "@/utils/streamList";

export default {
  name: "tone",
  namespaced: true,
  state: {
    toneList: [],
    loading: false,
    activeTone: "",
  },
  mutations: {
    SET_TONE_LIST(state, payload) {
      state.toneList = payload;
    },
    APPEND_TONE_LIST(state, payload) {
      state.toneList.push(payload);
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_ACTIVE_TONE(state, payload) {
      state.activeTone = payload;
    },
  },
  actions: {
    reset({ commit }) {
      stopStream("tone");
      commit("SET_TONE_LIST", []);
      commit("SET_ACTIVE_TONE", "");
      commit("SET_LOADING", false);
    },
    resetLoading({ commit, state, dispatch }) {
      if (state.loading) {
        commit("SET_LOADING", false);
        dispatch("getTones");
      }
    },
    async getTones({ dispatch, commit }, { retries = 0 } = {}) {
      if (retries === 0) {
        await dispatch("reset");
      }
      const controller = startStream("tone");
      commit("SET_TONE_LIST", []);
      commit("SET_LOADING", true);
      try {
        const { status, count } = await streamList(
          "generate/tones",
          {},
          {
            signal: controller.signal,
            onItem: (item) => {
              if (item.tone) commit("APPEND_TONE_LIST", item);
            },
          }
        );
        if (status === 401) {
          dispatch("modals/openAuth", null, { root: true });
        } else if (status >= 500 || (status === 200 && count === 0)) {
          throw new StreamError("No tones were generated");
        }
      } catch (error) {
        if (!isCurrentStream("tone", controller)) return;
        if (isRetryable(error) && retries < RETRY_LIMIT) {
          setTimeout(() => {
            if (isCurrentStream("tone", controller)) {
              dispatch("getTones", { retries: retries + 1 });
            }
          }, retryDelay(retries));
          return;
        }
        console.error(error);
      }
      if (isCurrentStream("tone", controller)) {
        finishStream("tone", controller);
        commit("SET_LOADING", false);
      }
    },
    addTone({ commit }, tone) {
      commit("APPEND_TONE_LIST", tone);
    },
    selectTone({ commit, state }, tone) {
      if (state.activeTone === tone) {
        commit("SET_ACTIVE_TONE", "");
        return;
      }
      commit("SET_ACTIVE_TONE", tone);
    },
  },
  getters: {},
  modules: {},
};
